exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-next {\r\n  float: right;\r\n}\r\n\r\nh4 {\r\n  margin-top: 10px;\r\n  font-weight: 700;\r\n}\r\n\r\nhr {\r\n  margin-bottom: 0;\r\n  margin-top: 0;\r\n}\r\n\r\n.label-value {\r\n  font-weight: 500;\r\n}\r\n\r\n.control-label {\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/main/pages/organization-add/organization-add.component.css
// module id = ../../../../../src/app/main/pages/organization-add/organization-add.component.css
// module chunks = main